module.exports = __webpack_public_path__ + "img/add.d816cc8e.svg";